import {fetchMJOData} from './MJO'
import {cacheApiResponse} from './api-cache'

const dealersAPI = '/api/dealers'

export async function dealerInfo({dealerCode, postcode, dealerTypes = ['sales']}) {
  const sortedDealerTypes = dealerTypes.sort()
  const apiOptions = {
    DealerCode: dealerCode || null,
    postcode: postcode || null,
    DealerType: sortedDealerTypes.join(','),
  }
  let dealers
  try {
    if (dealerCode || postcode) {
      const cacheKey = `localdealer_${dealerCode || postcode}_${sortedDealerTypes.join('_') ||
      'none'}`
      const {response} = await cacheApiResponse(cacheKey, () =>
        fetchFromApi(dealersAPI, apiOptions))
      dealers = response
    } else {
      throw new Error('Cannot complete dealer search without dealerCode or postcode')
    }
    return {response: dealers}
  } catch (error) {
    return {error}
  }
}

async function fetchFromApi(dealersAPI, options) {
  const dealers = await fetchMJOData(dealersAPI, options)
  return {data: dealers}
}



// WEBPACK FOOTER //
// ./src/apis/dealer-search.js